import React from 'react'
import Card from '../shared/card/card.jsx'
import root from '../shared/utils'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

export default React.createClass({
  render:function() {

  let taskProposedType = getTaskTypeIconParser(this.props.card.taskType)

  let mediaServer = root + '/common/latest/images/consumer/'
  let midIcon = mediaServer + 'gray-task-icons/' + taskProposedType.iconsrc
  let moduleType = this.props.card.moduleType
  let bgColor = taskProposedType.iconsrc + '-background'

  let btnId = 'taskProposedCard' + this.props.numOfProposedCards
  return (
    <Card
      headerTitle={this.props.card.header}
      cardClass={bgColor}
      headerMidIcon={midIcon}
      bodyText={this.props.card.content}
      moduleType={moduleType}
      btnText='View Proposal'
      btnStyle='btn btn-sm btn-link'
      btnId={btnId}
      btnOnClick={this.props.btnOnClick}
      noPullDown={this.props.noPullDown}>
      <p dangerouslySetInnerHTML={{ __html: this.props.card.content }} />
    </Card>
  )
}
})



// WEBPACK FOOTER //
// ./src/components/dashboard/task-proposed-card.jsx